import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import './serieSelector.scss';

class SerieSelectorCtrl {
    constructor($sce, imagesService, dataService) {
        if (angular.isUndefined(this.multiSelect)) {
            this.multiSelect = false;
        }

        if (angular.isUndefined(this.selectedSerie)) {
            this.selectedSerie = [];
        }

        this.sce = $sce;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.fieldName = null;
    }


    $onInit() {
        this.trustHtml();
    }

    trustHtml() {
        forEach(this.options, (el) => {
            if (angular.isDefined(el.attributes.details)) {
                this.sce.trustAsHtml(el.attributes.details);
            }
        });
    }

    getOptions() {
        return this.options;
    }

    toggleSelected(id) {
        if (this.multiSelect) {
            if (this.selectedSerie.indexOf(id) !== -1) {
                this.selectedSerie.splice(this.selectedSerie.indexOf(id), 1);
            } else {
                this.selectedSerie.push(id);
            }
        } else {
            this.selectedSerie = [id];
        }
        this.dataService.updateSelectedOptions('series', this.selectedSerie, 'series', false);
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptions = [];
    }

    getCaptionImage(type) {
        return this.imagesService.getCaptionImageUrl(this.defaultSelectedIdFieldName, type);
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    openModal(option) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: option.attributes.modalTitle,
                modalContent: option.attributes.modalContent,
                modalImgSrc: option.attributes.modalImgSrc
            });
        }
    }
}

SerieSelectorCtrl.$inject = ['$sce', 'imagesService', 'dataService'];

export default SerieSelectorCtrl;